import React from 'react';
import { Handle, Position } from 'reactflow';
import { Play } from 'lucide-react';

const StartNode = ({ data }) => {
  return (
    <div className="px-4 py-2 shadow-md rounded-lg bg-green-500 text-white border-2 border-green-600">
      <div className="flex items-center space-x-2">
        <Play className="h-4 w-4" />
        <div className="text-sm font-medium">{data.label}</div>
      </div>
      
      <Handle
        type="source"
        position={Position.Bottom}
        style={{
          background: '#10b981',
          border: '2px solid #059669',
        }}
      />
    </div>
  );
};

export default StartNode;